import {
  BooleanField,
  BooleanInput,
  Create,
  Datagrid,
  Edit,
  FormTab,
  FunctionField,
  List,
  NumberInput,
  SearchInput,
  TextField,
  TextInput,
} from "react-admin";
import { useCommonLabels } from "../i18n/hooks";
import { FilePreviewLink } from "../ui/fileUpload";
import { FormSection } from "../ui/forms/FormSection";
import { DescriptionLangFields, TitleLangFields } from "../ui/forms/langFields";
import { LangTabbedForm } from "../ui/forms/LangTabbedForm";
import { LocalizedFileControls, LocalizedFileLangField } from "../ui/forms/LocalizedFileInput";
import { normalizeContentRecord } from "../ui/forms/normalizeMedia";

const filters = [<SearchInput key="q" source="q" alwaysOn />];

const PhIntroForm = () => {
  const c = useCommonLabels();
  return (
    <LangTabbedForm>
      <FormTab label="Общее">
        <FormSection title="Настройки">
          <NumberInput source="SortOrder" label="Порядок" defaultValue={0} fullWidth />
          <BooleanInput source="Active" label={c.active} defaultValue />
        </FormSection>
        <FormSection title="Медиа">
          <LocalizedFileControls
            baseSource="Filename"
            label="Видео"
            kind="video"
            accept="video/*"
            required
            helperText="MP4 — загрузка через файловый сервис"
          />
        </FormSection>
      </FormTab>
      <FormTab label="🇦🇿 AZ">
        <TitleLangFields lang="AZ" titleRequired />
        <DescriptionLangFields lang="AZ" />
        <LocalizedFileLangField
          baseSource="Filename"
          lang="AZ"
          label="Видео"
          kind="video"
          accept="video/*"
          required
        />
      </FormTab>
      <FormTab label="🇷🇺 RU">
        <TitleLangFields lang="RU" titleRequired />
        <DescriptionLangFields lang="RU" />
        <LocalizedFileLangField
          baseSource="Filename"
          lang="RU"
          label="Видео"
          kind="video"
          accept="video/*"
          required
        />
      </FormTab>
      <FormTab label="🇬🇧 EN">
        <TitleLangFields lang="EN" titleRequired />
        <DescriptionLangFields lang="EN" />
        <LocalizedFileLangField
          baseSource="Filename"
          lang="EN"
          label="Видео"
          kind="video"
          accept="video/*"
        />
      </FormTab>
    </LangTabbedForm>
  );
};

export const PhIntroList = () => {
  const c = useCommonLabels();
  return (
    <List filters={filters} sort={{ field: "SortOrder", order: "DESC" }}>
      <Datagrid rowClick="edit" bulkActionButtons={false}>
        <TextField source="Id" label="ID" />
        <TextField source="TitleRU" label="Заголовок" />
        <TextField source="SortOrder" label="Порядок" />
        <FunctionField
          label="Видео"
          render={(record: { Filename?: string }) => <FilePreviewLink value={record.Filename} />}
        />
        <BooleanField source="Active" label={c.status} />
      </Datagrid>
    </List>
  );
};

export const PhIntroEdit = () => (
  <Edit mutationMode="pessimistic" transform={normalizeContentRecord}>
    <PhIntroForm />
  </Edit>
);

export const PhIntroCreate = () => (
  <Create transform={normalizeContentRecord}>
    <PhIntroForm />
  </Create>
);
